<template>
	<div class="logobox">
		<div class="logo">
			<div class="tel">

				<div class="phone">
					<input type="text" placeholder="手机号码">
				</div>
			</div>
			<div class="pass">

				<div class="code">
					<input type="password" placeholder="验证码">
					<div class="sendbox">
						<p v-if="sendcode" class="sendcode" @click="sendCode()">发送验证码</p>
						<p v-if="finish" class="sendcode2">
							<van-count-down :time="60000" format="ss" @finish='finishtime' /><span>秒后获取</span></p>
					</div>
				</div>
			</div>
			<div class="logobtn">
				<van-button type="info" size="large">登录</van-button>
			</div>
		</div>
		<van-field placeholder="" style='display: none;' />
	</div>
</template>

<script>
	export default {
		name: 'Logo',
		components: {

		},
		data() {
			return {
				sendcode: true, //显示发送验证码按钮
				finish: false //倒计时显示状态
			}

		},
		methods: {
			//倒计时结束
			finishtime() {
				this.sendcode = true;
				this.finish = false;
			},
			//发送验证码
			sendCode() {
				this.sendcode = false;
				this.finish = true;
			}
		}
	}
</script>

<style scoped>
	.logobox {
		width: 100%;
		height: 100%;
		background: #fafafa;
	}

	input {
		text-indent: 10px;
	}

	.logo {
		width: 95%;
		height: 200px;
		margin: 50px auto 0px auto;

	}

	.tel .phone {
		width: 100%;
		height: 30px;
		border-bottom: 1px solid #ccc;
	}

	.tel .phone input {
		background: none;
		outline: none;
		border: none;
		height: 30px;
		width: 100%;

	}

	.pass {
		margin-top: 20px;
		border-bottom: 1px solid #ccc;
		height: 35px;

	}

	.code {
		width: 100%;
		height: 30px;
		display: flex;
	}

	.code input {
		flex: 1;
		background: none;
		outline: none;
		border: none;
		height: 40px;

	}

	.sendbox {
		width: 80px;
		height: 40px;
		position: relative;
	}

	.sendbox .sendcode {

		line-height: 40px;
		font-size: 15px;
		font-weight: bold;
		color: #007CCF;
		position: absolute;
		top: 0px;
		left: 0px;
	}

	.sendbox .sendcode2 {

		line-height: 40px;
		font-size: 15px;
		font-weight: bold;
		color: #666;
		position: absolute;
		top: 0px;
		left: 0px;

	}

	.sendbox .sendcode2 span {
		margin-left: 20px;
		font-size: 12px;

	}


	.van-count-down {
		color: #323233;
		font-size: 14px;
		line-height: 20px;
		position: absolute;
		top: 10px;
	}

	.logop {
		font-size: 10px;
		font-weight: 100;
		line-height: 14px;
		color: rgba(51, 51, 51, 1);
	}

	.logobtn {
		width: 95%;
		height: 50px;
		margin: 20px auto;
		border-radius: 5px;
		overflow: hidden;
	}
</style>



// WEBPACK FOOTER //
// src/components/Logo.vue